import { INumberRangeAlertBehavior } from "./INumberRangeAlertBehavior";

export interface INumberRangeAlertBehaviorSpecifiable {
  numberRangeAlertBehavior: INumberRangeAlertBehavior;
}

export function instanceOfINumberRangeAlertBehaviorSpecifiable(instance: any): instance is INumberRangeAlertBehaviorSpecifiable {
  return instance
    && (instance.numberRangeAlertBehavior !== undefined);
}
